import * as React from 'react';
import Badge from '@material-ui/core/Badge';
import NotificationIcon from '~/assets/images/notification-icon.svg';
import NotificationIconRead from '~/assets/images/notification-icon-read.svg';

export default function BadgeNotificationMobile(props) {

  return (
    <Badge
      color={props.readValue === 0 ? "primary" : "error"}
      badgeContent={props.readValue}
      style={{ height: '80%', margin: `${props.readValue === 0 ? '0px' : '5px'} 0px 0px 20px` }}
    >
      {props.readValue === 0 ? 
      <img src={NotificationIcon} style={{ width: '100%'}} />
      : <img src={NotificationIconRead} style={{ width: '100%'}} />}
    </Badge>
  );
}
